import React from "react";
import InputAttribute from "../../molecules/InputAttribute";
import "./styles.css";

const DisplayStatus = (props) => {
    const { id, title, status, handleChange, value } = props;
    return (
        <ul className="status-container">
            <InputAttribute
                id={id}
                attributeName={title}
                value={value}
                handleChange={handleChange}
            />
            {status.map((displayStatus) => {
                return (
                    <li className="data-container" key={displayStatus.name}>
                        <span>{displayStatus.name}:</span>
                        <span>{displayStatus.displayValue}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default DisplayStatus;
